export type QueryState<T> =
  | { status: "loading" }
  | { status: "empty" }
  | { status: "data"; data: T }
  | { status: "error"; message: string };

export function resolveQueryState<T>(value: T | null | undefined, error?: string | null): QueryState<T> {
  if (error) return { status: "error", message: error };
  if (value === undefined) return { status: "loading" };
  if (value === null) return { status: "empty" };
  return { status: "data", data: value };
}
